goog.module('yext.developerapps.hubspotreviewgen.ReviewGenConfiguration');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const DialogView = goog.require('yext.apps.common.DialogView');
const routes = goog.require('yext.developerapps.routes');
const AddPropertyDialog = goog.require('yext.developerapps.hubspotreview.AddPropertyDialog');
const SuccessToast = goog.require('yext.apps.common.SuccessToast');

/**
 * @constructor
 */
const ReviewGenConfiguration = function() {
  this.$ctxt = $('.js-configuration-details');
  this.addFieldDialog = new AddPropertyDialog(this.$ctxt);
  this.init();
};

ReviewGenConfiguration.prototype.init = function() {
  var controller = this;
  this.bindAddField();
  this.addFieldDialog.setOnSave(function(newContactProperty) {
    controller.addContactProperty(newContactProperty);
  });
  this.addFieldDialog.init();
  this.successToast = new SuccessToast();
  this.successToast.init();
  this.bindSwitchViewEditMode();
  this.bindSaveConfiguration();
};

goog.exportSymbol('yext.developerapps.hubspotreviewgen.ReviewGenConfiguration', ReviewGenConfiguration);

ReviewGenConfiguration.prototype.bindAddField = function() {
  var controller = this;
  var $selects = controller.$ctxt.find('.js-select-property');
  this.$ctxt.on('change', '.js-select-property', function() {
    var value = this.value;
    if (value === 'ADDPROP') {
      controller.addFieldDialog.show();
    } else {
      $selects.find('option').prop('disabled', false);
      $selects.find(' option:selected').each(function() {
        var $option = $(this);
        $selects.find('option[value=' + this.value + ']')
          .filter(function() {
            return !$(this).is($option);
          })
          .prop('disabled', true);
      });
    }
  });
  $selects.trigger('change');
};

ReviewGenConfiguration.prototype.addContactProperty = function(contactProperty) {
  var $optionTemplate = $('<option value="' + contactProperty.name + '">' + contactProperty.label + '</option>');
  this.$ctxt.find('.js-select-property').each(function() {
    var $option = $optionTemplate.clone();
    $option.insertBefore($(this).children().last());
    if (this.value == 'ADDPROP') {
      $option.prop('selected', true);
    }
  });
  this.$ctxt.find('.js-select-property').last().trigger('change');
};

ReviewGenConfiguration.prototype.bindSwitchViewEditMode = function() {
  var controller = this;
  this.$ctxt.find('#viewEdit-btn').on('click', function() {
    controller.switchViewEditMode(false);
  });

  this.$ctxt.find('#cancelEdit-btn').on('click', function() {
    controller.switchViewEditMode(true);
  });
};

ReviewGenConfiguration.prototype.switchViewEditMode = function(isView) {
  var elements = document.getElementsByClassName('viewMode');
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.display = isView ? 'block' : 'none';
  }
  elements = document.getElementsByClassName('editMode');
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.display = isView ? 'none' : 'block';
  }
};

ReviewGenConfiguration.prototype.bindSaveConfiguration = function() {
  var controller = this;
  this.$ctxt.find('#add-btn').on('click', function() {
    controller.saveConfiguration(function(result) {
      if (result['success']) {
        window.location.reload();
      } else if (result['errors']) {
        controller.handleSaveErrors(result['errors']);
      } else {
        controller.showGenericError(yext.msg('Error saving configuration.'));
      }
    });
  });

  this.$ctxt.find('#saveEdit-btn').on('click', function() {
    controller.saveConfiguration(function(result) {
      if (result['success']) {
        window.location.reload();
      } else if (result['errors']) {
        controller.handleSaveErrors(result['errors']);
      } else {
        controller.showGenericError(yext.msg('Error saving configuration.'));
      }
    });
  });
};

ReviewGenConfiguration.prototype.saveConfiguration = function(successCallback) {
  var configuration = {};
  configuration['id'] = this.$ctxt.find('input[name=id]').val();

  configuration['storeIdField'] = this.getFieldValue('#storeIdField');
  configuration['firstNameField'] = this.getFieldValue('#firstNameField');
  configuration['lastNameField'] = this.getFieldValue('#lastNameField');
  configuration['emailField'] = this.getFieldValue('#emailField');
  configuration['phoneField'] = this.getFieldValue('#phoneField');
  configuration['usePhone'] = this.$ctxt.find('#usePhone').val();

  $.ajax({
    method: 'POST',
    url: routes.HubspotReviewGen.saveConfiguration(),
    data: JSON.stringify(configuration),
    contentType: 'application/json',
  })
    .done(successCallback);
};

ReviewGenConfiguration.prototype.getFieldValue = function(field) {
  return this.$ctxt.find(field).val() != '0' ? this.$ctxt.find(field).val(): '';
};

ReviewGenConfiguration.prototype.handleSaveErrors = function(errors) {
  var controller = this;
  $.each(errors, function(i, error) {
    var fieldName = error['fieldName'];
    var errorMessage = error['errorMessage'].replace('\n', '<br>');
    if (fieldName === 'general') {
      controller.showGenericError(errorMessage);
    } else {
      var $field = controller.$ctxt.find('.js-' + fieldName + '-field');
      $field.find('.js-field-error')
        .text(errorMessage)
        .show();
      $field.find('input[type=text], select')
        .addClass('error');
    }
  });
};

ReviewGenConfiguration.prototype.showGenericError = function(errorMessage) {
  this.$ctxt.find('.js-general-error')
    .text(errorMessage)
    .show();
};

exports = ReviewGenConfiguration;
